import {
  Datagrid,
  DateField,
  EditButton,
  ImageField,
  List,
  RichTextField,
  TextField,
} from "react-admin";

export function AchievementList(props) {
  return (
    <List {...props}>
      <Datagrid rowClick="show">
        <TextField source="name" />
        <RichTextField source="description" />
        <DateField source="createdDate" showTime />
        <DateField source="updatedDate" showTime />
        <ImageField
          source="images[0].link"
          title="images[0].name"
          sx={{
            "& img": { maxWidth: 50, maxHeight: 50, objectFit: "contain" },
          }}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
}
